import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Device } from 'src/app/models/devicetype';
import { MeetingService } from 'src/app/services/meetings/meeting.service';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-meeting-page',
  templateUrl: './meeting-page.component.html',
  styleUrls: ['./meeting-page.component.css'],
})
export class MeetingPageComponent implements OnInit {
  meetingUrl: string = 'https://vcircle.ng/join/';
  meetingId: string = '';
  returnurl = '';
  @ViewChild('meetingIframe') meetingIframe: ElementRef;

  constructor(
    private meetingServices: MeetingService,
    public util: UtilService,
    public toastr: ToastrService,
    private activatedroute: ActivatedRoute
  ) {}

  async ngOnInit() {
    this.meetingId = this.activatedroute.snapshot.queryParams.meetingid;
    console.log(this.meetingId);
    let isMobile =
      this.util.getDeviceType() == Device.Android ||
      this.util.getDeviceType() == Device.IOS;
    try {
      let meetingData: any = await this.meetingServices
        .getMeetingInfo(this.meetingId)
        .toPromise();
      let classId = meetingData.res.classid;
      let moduleID = meetingData.res.moduleid;
      let location = window.location.origin;
      if (classId) {
        this.returnurl =
          location + `/user/lesson?classid=${classId}&moduleid=${moduleID}`;
      } else {
        this.returnurl += location + '/user/moduledetails?moduleID=' + moduleID;
      }
      this.meetingUrl += this.meetingId + '?auth=' + meetingData.res.jwt;

      // if (isMobile) {
      //   this.meetingIframe.nativeElement.src = this.meetingUrl;
      //   window.addEventListener('message', this.meetingEvent.bind(this), false);
      // } else {
        const anchor = document.createElement('a');
        anchor.href = this.meetingUrl;
        anchor.click();
      // }
    } catch (error) {
      //delay 2sec so user can see an error occured
      setTimeout(() => {
          window.close();
      }, 2000);
    } finally {
      console.log(this.returnurl);
    }
  }

  meetingEvent(event: Event) {
    // Handle the event data sent from the iframe
    console.log(this.returnurl);

    const data = (event as MessageEvent).data;
    if (data.messageId == 'user-left') {
      window.location.href = this.returnurl;
    }
  }
}
